import { useEffect, useState } from "react";
import { tokenHelper } from "../stores/helpers";

export const Permission = ({ level, feature, children }) => {
  const [permissions, setPermissions] = useState({});
  const [currentUser, setCurrentUser] = useState({});
  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const perms = await tokenHelper.getPermissions();
      const user = await tokenHelper.getUser();
      setCurrentUser(user);
      setPermissions(perms || {});
    };
    fetchUserAndPermissions();
  }, []);

  if ((permissions?.[feature] ?? 0) >= level || currentUser?.role === "ROOT")
    return children;
  return null;
};
